import { IconSvg, IconSvgProps } from "./icon"

export default function CreateFill(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 3c-2.33 0-4.766 0-6.798.459-.453.104-.87.365-1.2.752a3.01 3.01 0 0 0-.654 1.422C3 7.541 3 9.3 3 12s0 4.457.348 6.367a3.01 3.01 0 0 0 .654 1.422c.33.387.747.648 1.2.752C7.234 21 9.672 21 11.999 21c2.33 0 4.765 0 6.798-.459.452-.104.87-.365 1.2-.752.33-.387.557-.881.653-1.422.348-1.908.348-3.667.348-6.367s0-4.457-.348-6.367a3.01 3.01 0 0 0-.654-1.422 2.246 2.246 0 0 0-1.2-.752C16.765 3 14.328 3 12 3Z" />
      {/* The square, filled, with a plus cut out the width of a 1.5 stroke */}
      <path
        d="M12 3c-2.33 0-4.766 0-6.798.459-.453.104-.87.365-1.2.752a3.01 3.01 0 0 0-.654 1.422C3 7.541 3 9.3 3 12s0 4.457.348 6.367a3.01 3.01 0 0 0 .654 1.422c.33.387.747.648 1.2.752C7.234 21 9.672 21 11.999 21c2.33 0 4.765 0 6.798-.459.452-.104.87-.365 1.2-.752.33-.387.557-.881.653-1.422.348-1.908.348-3.667.348-6.367s0-4.457-.348-6.367a3.01 3.01 0 0 0-.654-1.422 2.246 2.246 0 0 0-1.2-.752C16.765 3 14.328 3 12 3ZM11.25 9a.75.75 0 0 1 1.5 0v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25Z"
        fill="currentColor"
        fillRule="evenodd"
        stroke="none"
      />
    </IconSvg>
  )
}
